import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { format } from "date-fns";
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";

class ProviderInvitationsPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        this.getData()
    }

    async getData(){
        const res = await axios.get('/api/providers/invitations/statistics')
        this.setState({data: res.data})

        this.initChart('#chart_empleado', res.data.dossiersEmployee);
        this.initChart('#chart_proveedor', res.data.dossiersProviders);
        this.initChart('#chart_cliente', res.data.dossiersClient);
    }

    getTotalByStatus (data, status) {
        var found = data.filter(function(obj){ return obj.status+"" === status; })[0];

        if(found != undefined){
            return found.total;
        }else{
            return 0;
        }
    }

    initChart(html_id, data){
        var aceptadas   = this.getTotalByStatus(data, 'Aceptada');
        var declinadas  = this.getTotalByStatus(data, 'Declinado');
        var pendientes  = this.getTotalByStatus(data, 'Invitado');

        var options = {
            colors: ['#844AFF', '#767676', '#C2C2C2'],
            series: [aceptadas, declinadas, pendientes],
            labels: ["Aceptadas", "Declinadas", "Pendientes"],
            chart: {
                width: '100%',
                type: 'donut',
                height: 155,
            },
            stroke: {
                width: 0,
            },
            dataLabels: {
                enabled: false,
                style: {
                    fontSize: "8px",
                }
            },
            legend: {
                show: false
            },
            responsive: [{
                breakpoint: 978,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    }
                }
            }],
            plotOptions: {
                pie: {
                    donut: {
                        size: '83%',
                        labels: {
                            show: true,
                            total: {
                                show: true,
                                //label: 'aaa',
                                //formatter: () => 'Text you want'
                                fontSize: '12px',
                            },
                            value: {
                                offsetY: 2,
                            },
                        }
                    }
                }
            }
        };

        var chart = new ApexCharts(document.querySelector(html_id), options);
        chart.render();
    }

    render() {
        const { lang } = this.context; 
        return (<div>
            <div className="row mb-2">
                <div className="col-4">
                    <h3 className="card-title m-0">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.invitaciones')}</span>
                    </h3>
                </div>
                <div className="col-8">
                    <ul className="nav nav-pills nav-pills-sm nav-dark"> 
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 active font-weight-bolder font-size-sm" data-toggle="tab" href="#i_proveedores">{lang.get('messages.proveedores')}</a>
                        </li>  
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 font-weight-bolder font-size-sm" data-toggle="tab" href="#i_empleados">{lang.get('messages.empleados')}</a>
                        </li> 
                        <li className="nav-item ml-0">
                            <a className="nav-link py-2 px-4 font-weight-bolder font-size-sm" data-toggle="tab" href="#i_clientes">{lang.get('messages.clientes')}</a>
                        </li>     
                    </ul>
                </div>
            </div>
            <div className="tab-content">
                <div className="tab-pane fade show active" id="i_proveedores" role="tabpanel" aria-labelledby="i_proveedores">
                    <div className="row">
                        <div className="col-4">
                            <div className="flex-row-fluid pt-5">
                                <div className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data==null ? 0 : this.state.data.totalDossierProviders } de { this.state.data==null ? 0 : this.state.data.total }
                                </div>
                                <span className="text-muted font-weight-bold">{lang.get('messages.total_de_invitaciones_enviadas_a_proveedores')}</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="mt-7">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-500"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.pendientes')}</span>
                            </div>
                            <div className="mt-5">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-700"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.declinadas')}</span>
                            </div>
                        </div>
                        <div className="col-5" style={{ marginTop: '0px' }}>
                            <div id="chart_proveedor" className="d-flex justify-content-center"></div>
                        </div>                            
                    </div>
                </div>
                <div className="tab-pane fade show" id="i_empleados" role="tabpanel" aria-labelledby="i_empleados">
                    <div className="row">
                        <div className="col-4">
                            <div className="flex-row-fluid pt-5">
                                <div className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data==null ? 0 : this.state.data.totalDossierEmployee } {lang.get('messages.de')} { this.state.data==null ? 0 : this.state.data.total }
                                </div>
                                <span className="text-muted font-weight-bold">{lang.get('messages.total_de_invitaciones_enviadas_a_empleados')}</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="mt-7">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-500"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.pendientes')}</span>
                            </div>
                            <div className="mt-5">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-700"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.declinadas')}</span>
                            </div>
                        </div>
                        <div className="col-5" style={{ marginTop: '0px' }}>
                            <div id="chart_empleado" className="d-flex justify-content-center"></div>
                        </div>                            
                    </div>
                </div>
                <div className="tab-pane fade show" id="i_clientes" role="tabpanel" aria-labelledby="i_clientes">
                    <div className="row">
                        <div className="col-4">
                            <div className="flex-row-fluid pt-5">
                                <div className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data==null ? 0 : this.state.data.totalDossierClient } {lang.get('messages.de')} { this.state.data==null ? 0 : this.state.data.total }
                                </div>
                                <span className="text-muted font-weight-bold">{lang.get('messages.total_de_invitaciones_enviadas_a_solicitantes')}</span>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="mt-7">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-500"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.pendientes')}</span>
                            </div>
                            <div className="mt-5">
                                <div className="symbol symbol-30 bg-gray-100 mr-3" style={{ verticalAlign: 'middle' }}>
                                    <i className="symbol-badge bg-gray-700"></i>
                                </div>
                                <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg text-muted">{lang.get('messages.declinadas')}</span>
                            </div>
                        </div>
                        <div className="col-5" style={{ marginTop: '0px' }}>
                            <div id="chart_cliente" className="d-flex justify-content-center"></div>
                        </div>                            
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default ProviderInvitationsPanel;

if (document.getElementById('ProviderInvitationsPanel')) {
    ReactDOM.render(<ProviderInvitationsPanel />, document.getElementById('ProviderInvitationsPanel'));
}
